define('ordersOrderUtils',[
  'app',
  'module',
  'underscore',
  'settings',
  'entities/customers/customers',
  'entities/orders'
], function (
  App,
  module,
  _,
  Settings
) {
  'use strict';

  module.exports = {
    getWebshopUrl: function (order, customer) {     
      var urls = Settings.get('webshopUrl');
      if(!urls)
        return null;

      if(order && order.get('webShopLocale') && urls[order.get('webShopLocale')])
        return urls[order.get('webShopLocale')];
            
      var lang = null;
      var countryCode = null;

      if (Settings.configValue('customerDefaultMailLanguage'))
        lang = Settings.configValue('customerDefaultMailLanguage');
      
      if(customer) {
        if (customer.get('locales') && (customer.get('locales')).length >= 2)
          lang = (customer.get('locales')).substring(0, 2);

        if (customer.get('countryCode') && (customer.get('countryCode')).length >= 2)
          countryCode = (customer.get('countryCode')).substring(0, 2);

        if (lang && countryCode && urls[lang.toLowerCase() + '_' + countryCode.toUpperCase()])
          return urls[lang.toLowerCase() + '_' + countryCode.toUpperCase()];

        if (lang && urls[lang.toLowerCase()])
          return urls[lang.toLowerCase()];
      }

      return urls[''];
    },

    getProofSheetUrl: function (order, customer, tracking, pdf) {     
      var url = null;

      if(!order)   
        return null;
     
      if (Settings.configValue('advancedMode') === false)
        tracking = true;      
  
      var webshopBaseUrl = this.getWebshopUrl(order, customer);
      if(webshopBaseUrl) {     
        if (pdf === true)
          url = webshopBaseUrl + '/proofsheet/pdf/' + order.get('purchaseOrderId');
        else if (tracking === true)
          url = webshopBaseUrl + '/proofsheet/' + order.get('purchaseOrderId');
        else
          url = webshopBaseUrl + '/proofsheet/notrack/' + order.get('purchaseOrderId');
      } 

      return url;         
    },

    getProductionSheetUrl: function (order, customer, tracking, pdf) {
      var url = null;
      if(!order)
        return null;

      var wsLocale = Settings.getWebshopLocales();
      var webshopBaseUrl = _.findWhere(wsLocale, {code: 'en_US'}).value;
      if(webshopBaseUrl) {
        if (pdf === true)
          url = webshopBaseUrl + '/productionsheet/pdf/' + order.get('purchaseOrderId');
        else if (tracking === true)
          url = webshopBaseUrl + '/productionsheet/' + order.get('purchaseOrderId');
        else
          url = webshopBaseUrl + '/productionsheet/notrack/' + order.get('purchaseOrderId');
      }
      return url;
    }
  };
});

